module.exports = __webpack_public_path__ + "static/media/am.f2e1fa73.svg";